import { defineStore } from 'pinia';
import { axios } from '@boot/axios.js';
/**
 * Return the default state for the defects store.
 */
function getDefaultState() {
    return {
        defects: {}
    };
}
/**
 * Formats a defect object.
 */
function formatDefect(defect) {
    return {
        id: defect.id,
        facility: defect.facility,
        name: defect.name,
        code: defect.code,
        description: defect.description
    };
}
/**
 * Store for managing defect data.
 */
export const useDefectsStore = defineStore('defects', {
    state: () => getDefaultState(),
    getters: {
        /**
         * Retrieves a defect from the state by its ID.
         */
        getDefect: state => {
            return (id) => {
                const defectId = Number(id);
                if (defectId in state.defects) {
                    return state.defects[defectId];
                }
                else {
                    return null;
                }
            };
        }
    },
    actions: {
        /**
         * Reset store state.
         */
        resetState() {
            this.$reset();
        },
        /**
         * Loads defects for a specific facility and commits them to the store.
         */
        async loadFacilityDefectsAction(payload) {
            const { facilityId } = payload;
            try {
                const response = await axios.get(`defects/?facility=${facilityId}`);
                const defects = response.data.results;
                defects.forEach((defect) => {
                    const formatted = formatDefect(defect);
                    this.defects[formatted.id] = { ...formatted };
                });
            }
            catch (error) {
                console.error('Failed to load defects due to: ', error);
                throw error;
            }
        },
        /**
         * Add a defect to the store.
         */
        addDefectAction(defect) {
            this.defects[defect.id] = { ...defect };
        }
    }
});
